module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell"
  }, [(_vm.sneaker != null) ? _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": _vm.sneaker.image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-section"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.sneaker.brand))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sneaker.model_name))]), _vm._v(" "), _c('div', {
    staticClass: "grid-x card-info"
  }, [_c('div', {
    staticClass: "small-5 small-offset-1"
  }, [_c('p', [_vm._v(_vm._s(_vm.sneaker.release_date_pretty))])]), _vm._v(" "), _c('div', {
    staticClass: "small-5 small-offset-1"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("price")(_vm.sneaker.original_price)))])])]), _vm._v(" "), (_vm.user) ? _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.addSneakerToWishlist()
      }
    }
  }, [_vm._v("Add to wishlist")]), _vm._v(" "), _c('button', {
    staticClass: "button alert",
    on: {
      "click": function($event) {
        _vm.removeSneakerFromWishlist()
      }
    }
  }, [_vm._v("Remove from wishlist")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.addSneakerToCollection()
      }
    }
  }, [_vm._v("Add to collection")]), _vm._v(" "), _c('button', {
    staticClass: "button alert",
    on: {
      "click": function($event) {
        _vm.removeSneakerFromCollection()
      }
    }
  }, [_vm._v("Remove from collection")])]) : _c('div', [_c('p', [_vm._v("Please \n                                "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("log in")]), _vm._v(" or\n                                "), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("sign up")]), _vm._v(" to add to wishlist or collection.\n                            ")], 1)])])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a37d99e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sneaker.vue
// module id = 74
// module chunks = 0